import React from 'react'

import { SmallLabel, MatchWrap, NameWrap, LocationWrap } from './styled'

import { PhotoProgressBar } from 'src/components/PhotoProgressBar/PhotoProgressBar'
import { InstagramIcon, TwitterIcon } from 'src/components/Icons'
import { Connection } from 'src/api/connections/types'

interface Props {
  connection: Connection
}

export const OtherUserPreview: React.FC<Props> = ({
  connection: { matchPercent, id, otherUser },
}) => (
  <>
    <SmallLabel>Total Score</SmallLabel>
    <MatchWrap>{matchPercent ? `${String(matchPercent)}%` : '-'}</MatchWrap>
    <div>
      <PhotoProgressBar
        uniqueIdentifier={id}
        imgUrl={otherUser.profilePicture}
        progress={100}
        size={120}
        strokeWidth={4}
      />
    </div>
    <NameWrap>{otherUser.firstName}</NameWrap>
    <LocationWrap>
      {otherUser.city.name}, {otherUser.city.country}
    </LocationWrap>
    <div>
      {otherUser.instagram && (
        <a
          href={`https://www.instagram.com/${otherUser.instagram}`}
          rel="noopener noreferrer"
          target="_blank"
        >
          <InstagramIcon />
        </a>
      )}
      {otherUser.twitter && (
        <a
          href={`https://www.tiwtter.com/${otherUser.twitter}`}
          rel="noopener noreferrer"
          target="_blank"
        >
          {' '}
          <TwitterIcon />
        </a>
      )}
    </div>
  </>
)
